export const positionConfig = {
  docType: "Position",
  title: "Position",
  description: "Position desc",
  apiConfig: {
    add: "/admin/position/add",
    edit: "/admin/position/edit",
  },
  dataMapper: (item, index) => ({
    key: index + 1,
    ...item,
    approver_name: item?.approver?.position_name,
    position_name_unit: item?.position_name + " - " + item?.unit,
    is_approver_display: item?.is_approver ? "Approver" : "Employee",
    is_faculty_display: item?.is_faculty ? "Faculty" : "Not Faculty",
  }),
  appDataMapper: (item) => ({
    label: item?.position_name + " - " + item?.unit,
    name: item?.id,
  }),
  columns: [
    {
      title: "No.",
      dataIndex: "key", width: 60,
      rowScope: "row",
    },
    {
      title: "Position Name",
      dataIndex: "position_name",
      key: "position_name",
      sortable: true,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      sortable: true,
    },
    {
      title: "Type",
      dataIndex: "is_approver_display",
      key: "is_approver_display",
    },
    {
      title: "Is Faculty",
      dataIndex: "is_faculty_display",
      key: "is_faculty_display",
    },
    {
      title: "Approver Name",
      dataIndex: "approver_name",
      key: "approver_name",
    },
  ],
  formFields: [
    {
      label: "Position Id",
      name: "id",
      disabled: true,
    },
    {
      label: "Position Name Unit",
      name: "position_name",
      rules: [{ required: true }],
    },
    {
      label: "Unit",
      name: "unit",
      type: "select",
      selectItems: [
        {
          name: "Accounting Office",
          label: "Accounting Office",
        },
        {
          name: "Office of the Vice Chancellor for Finance and Administration",
          label: "OVCFA",
        },
        {
          name: "Faculty of Information and Communication Studies",
          label: "FICS",
        },
        {
          name: "Center for Open and Digital Teaching and Learning",
          label: "CODTL",
        },
        {
          name: "Faculty of Education",
          label: "FEd",
        },
        {
          name: "Information & Communication Technology Development Office",
          label: "ICTDO",
        },
        {
          name: "Faculty of Management and Development Studies",
          label: "FMDS",
        },
        {
          name: "Budget Office",
          label: "Budget Office",
        },
        {
          name: "Office of the University Registrar",
          label: "OUR",
        },
        {
          name: "Campus Development and Maintenance Office",
          label: "CDMO",
        },
        {
          name: "Office of the Vice Chancellor for Academic Affairs",
          label: "OVCAA",
        },
        {
          name: "Supply and Property Management Office",
          label: "SPMO",
        },
        {
          name: "Cash Office",
          label: "Cash Office",
        },
        {
          name: "Office of the Chancellor",
          label: "OC",
        },
        {
          name: "Human Resources Development Office",
          label: "HRDO",
        },
        {
          name: "Quality Assurance Office",
          label: "QAO",
        },
        {
          name: "Office of Public Affairs",
          label: "OPA",
        },
        {
          name: "Ugnayan ng Pahinungod/Oblation Corps Office",
          label: "Pahinungod",
        },
        {
          name: "Office of Gender Concerns",
          label: "OGC",
        },
        {
          name: "Office of Student Affairs",
          label: "OSA",
        },
        {
          name: "Faculty of Information and Communication Studies",
          label: "FICS",
        },
        {
          name: "Office of the Legal Counsel",
          label: "Office of the Legal Counsel",
        },
        {
          name: "University Library",
          label: "University Library",
        },
      ],
    },
    {
      label: "Is Approver",
      name: "is_approver",
      type: "select",
      selectItems: [
        {
          label: "Yes (Approver)",
          name: true,
        },
        {
          label: "No (Employee)",
          name: false,
        },
      ],
    },
    {
      label: "Is Faculty",
      name: "is_faculty",
      type: "select",
      selectItems: [
        {
          label: "Yes (Faculty)",
          name: true,
        },
        {
          label: "No (Not Faculty)",
          name: false,
        },
      ],
    },
  ],
  viewingDataConfig: [
    {
      key: 1,
      collapseName: "Required Details",
      collapseItems: [
        { key: 1, name: "position_name", label: "Position" },
        { key: 2, name: "unit", label: "Unit" },
        { key: 3, name: "is_approver_display", label: "Type" },
        { key: 4, name: "is_faculty_display", label: "Is Faculty" },
        // { key: 3, name: "approver_id", label: "Approver ID" },
      ],
    },
  ],
};
